import React, {useEffect, useState} from 'react';
import {Card} from "../../../../../../../components/card/card.jsx";
import Button from "../../../../../../../components/button/button.jsx";
import TreeUsers from "../../../../../../../components/tree-user/tree-users.jsx";
import ModalAddUsers from "./modal-add-users.jsx";
import ModalRemoveUsers from "./modal-remove-users.jsx";

const Responsible = ({responsible, setResponsible}) => {
    const [responsibleSelect, setResponsibleSelect] = useState([])
    const [showModalAddUser, setShowModalAddUser] = useState(false);
    const [showModalRemoveUser, setShowModalRemoveUser] = useState(false);

    useEffect(() => {
        setResponsibleSelect(responsible.map(g => ({label: g.description, value: g.id})))
    }, [responsible]);

    return (
        <>
            <Card>
                <Card.Header>
                    <Card.Title>Almoxarifes permitidos</Card.Title>
                </Card.Header>
                <Card.Body className={"responsible-tree"}>
                    <TreeUsers users={responsible}/>
                </Card.Body>
                <Card.Footer>
                    <div className="flex gap-2 w-full justify-end items-center">
                        <Button target="danger" onClick={() => setShowModalRemoveUser(true)}>Remover almoxarifes</Button>
                        <Button onClick={() => setShowModalAddUser(true)}>Adicionar almoxarifes</Button>
                    </div>
                </Card.Footer>
            </Card>

            <ModalAddUsers
                show={showModalAddUser}
                setShow={setShowModalAddUser}
                responsible={responsible}
                setResponsible={setResponsible}
            />

            <ModalRemoveUsers
                show={showModalRemoveUser}
                setShow={setShowModalRemoveUser}
                responsible={responsible}
                setResponsible={setResponsible}
            />
        </>
    );
};

export default Responsible;